import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/auth/me`, { withCredentials: true });
      setUser(res.data);
    } catch {
      setUser(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const sendMagicLink = async (email) => {
    const res = await axios.post(`${API}/auth/magic-link`, { email }, { withCredentials: true });
    return res.data;
  };

  const verifyToken = async (token) => {
    const res = await axios.post(`${API}/auth/verify`, { token }, { withCredentials: true });
    setUser(res.data);
    return res.data;
  };

  const logout = async () => {
    await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    setUser(null);
  };

  const buyCredits = async (amountCents) => {
    const res = await axios.post(`${API}/billing/buy-credits`, { amount_cents: amountCents }, { withCredentials: true });
    window.location.href = res.data.checkout_url;
  };

  const getBalance = async () => {
    const res = await axios.get(`${API}/billing/balance`, { withCredentials: true });
    setUser((prev) => (prev ? { ...prev, ...res.data } : prev));
    return res.data;
  };

  const onboardUser = async ({ name, company, phone }) => {
    const res = await axios.post(`${API}/auth/onboard`, { name, company, phone }, { withCredentials: true });
    setUser(res.data);
    return res.data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, sendMagicLink, verifyToken, logout, checkAuth, buyCredits, getBalance, onboardUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}
